import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import AdminPage from '../../../admin/shared/AdminPage'
import Loading from '../../../../molecules/Loading'
import { dataCatalog } from '../../../../../api/coreData'
import EmptySection from '../../../../atoms/EmptySection'
import SydTabs from '../../../../commonDesign/SydTabs'
import DatasourceHeader from './DatasourceHeader'
import DetailsTab from './DetailsTab'
import AuditTab from './AuditTab'
import RestrictionsTab from './RestrictionsTab'

const tabOptions = {
  details: {
    label: 'Details'
  },
  restrictions: {
    label: 'Restrictions'
  },
  logs: {
    label: 'Logs'
  }
}
const DEFAULT_TAB = 'details'

function DataSourceDetails () {
  const { datasourceId } = useParams()
  const { data, isLoading } = dataCatalog.useGetCatalogDataSource(datasourceId)
  const [currentTab, setCurrentTab] = useState(DEFAULT_TAB)

  if (isLoading) {
    return (
      <AdminPage>
        <Loading />
      </AdminPage>
    )
  }

  if (!data?.datasource) {
    return (
      <AdminPage>
        <EmptySection title='Not Available' description='' />
      </AdminPage>
    )
  }

  const datasource = data?.datasource

  return (
    <AdminPage key='data-source-details-main'>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <DatasourceHeader datasource={datasource} />
        </Grid>
        <Grid item xs={12}>
          <SydTabs.Group
            tabOptions={tabOptions}
            defaultValue={DEFAULT_TAB}
            onChange={setCurrentTab}
          >
            <div className='mb-2'>
              <SydTabs.Links />
            </div>
          </SydTabs.Group>
          {currentTab === 'details' ? (
            <DetailsTab datasource={datasource} />
          ) : (currentTab === 'restrictions') ? (
            <RestrictionsTab datasource={datasource} />
          ) : (currentTab === 'logs') ? (
            <AuditTab datasource={datasource} />
          ) : (
            <div>Unknown</div>
          )}
        </Grid>
      </Grid>
    </AdminPage>
  )
}

DataSourceDetails.propTypes = {
}

export default DataSourceDetails
